"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
load_themed_styles_1.loadStyles([{ "rawString": ".editingInput_538c5bee{border:0px;outline:none;width:100%}.editingInput_538c5bee::-ms-clear{display:none}.editingContainer_538c5bee{margin:4px}\n" }]);
exports.editingInput = "editingInput_538c5bee";
exports.editingContainer = "editingContainer_538c5bee";
//# sourceMappingURL=EditingItem.scss.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/SelectedItemsList/SelectedPeopleList/Items/EditingItem.scss.js
// module id = 1058
// module chunks = 0